import type { CalendarRange } from '@wtfalch/calendar/calendar';

/** How soon a free slot must start to count as "free now". `findTime` clips
 *  its first slot to the start of the range it was asked about. */
const NOW_SLACK_MS = 60_000;

/**
 * "Free until 3:30 PM" from a person's free slots (`findTime`'s answer, in
 * order), or `null` when they are not free right now: the first slot starts
 * later, or there is none. A slot whose times do not parse is not believed.
 */
export function freeUntilLabel(
  slots: readonly CalendarRange[],
  now: Date,
  locale?: string,
): string | null {
  const first = slots[0];
  if (!first) return null;
  const start = new Date(first.after).getTime();
  const end = new Date(first.before).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return null;
  if (start - now.getTime() > NOW_SLACK_MS || end <= now.getTime()) return null;
  return `Free until ${new Date(end).toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' })}`;
}
